import { DESCENDING } from 'constants/sortDirections';
import { SORT_DIRECTIONS } from 'constants/sortDirectionsEnum';
import { FC, useState } from 'react';
import { TabSpecificFiltersContext } from './TabSpecificFiltersContext';

export const TabSpecificFiltersContextProvider: FC<React.PropsWithChildren<unknown>> = ({
  children,
}) => {
  const [campaignsSortedBy, setCampaignsSortedBy] = useState('id');
  const [campaignsSortDirection, setCampaignsSortDirection] = useState(DESCENDING);
  const [audienceSortedBy, setAudienceSortedBy] = useState('Segment');
  const [audienceSortDirection, setAudienceSortDirection] = useState(DESCENDING);
  const [selectedSegment, setSelectedSegment] = useState({});
  const [region, setRegion] = useState(['021']);
  const [snippetsSortedBy, setSnippetsSortedBy] = useState('TotalSent');
  const [snippetsSortDirection, setSnippetsSortDirection] = useState(SORT_DIRECTIONS.DESCENDING);

  return (
    <TabSpecificFiltersContext.Provider
      value={{
        campaignsSortedBy,
        setCampaignsSortedBy,
        campaignsSortDirection,
        setCampaignsSortDirection,
        audienceSortedBy,
        setAudienceSortedBy,
        audienceSortDirection,
        setAudienceSortDirection,
        selectedSegment,
        setSelectedSegment,
        region,
        setRegion,
        snippetsSortedBy,
        setSnippetsSortedBy,
        snippetsSortDirection,
        setSnippetsSortDirection,
      }}
    >
      {children}
    </TabSpecificFiltersContext.Provider>
  );
};
